import { useSyncExternalStore } from 'react'

const coarse = typeof window !== 'undefined' ? window.matchMedia('(pointer: coarse)') : null
/** Whether this is a touch screen (a phone or tablet, no mouse): kept current. */
export function useTouchDevice(): boolean {
  return useSyncExternalStore(
    (cb) => (coarse?.addEventListener('change', cb), () => coarse?.removeEventListener('change', cb)),
    () => coarse?.matches ?? false,
  )
}

const wide = typeof window !== 'undefined' ? window.matchMedia('(min-width: 768px)') : null
/** Desktop layout (the left column) or the phone one (the bar at the bottom): kept current. */
export function useIsDesktop(): boolean {
  return useSyncExternalStore(
    (cb) => (wide?.addEventListener('change', cb), () => wide?.removeEventListener('change', cb)),
    () => wide?.matches ?? true,
  )
}
